// pages/PrivacyPolicyPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield, Lock, Eye, Database, Phone, Mail, MapPin } from 'lucide-react';

const PrivacyPolicyPage = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = React.useState(window.innerWidth <= 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#fff5f5' }}>
      {/* Header */}
      <div style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: '#dc2626',
        padding: isMobile ? '12px 16px' : '16px 24px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', alignItems: 'center', gap: '16px' }}>
          <button
            onClick={() => navigate(-1)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              background: 'rgba(255,255,255,0.2)',
              border: 'none',
              padding: isMobile ? '6px 12px' : '8px 16px',
              borderRadius: '8px',
              cursor: 'pointer',
              color: 'white',
              fontWeight: 500
            }}
          >
            <ArrowLeft size={isMobile ? 14 : 16} /> Back
          </button>
          <div>
            <h1 style={{ fontSize: isMobile ? '1rem' : '1.3rem', fontWeight: 700, margin: 0, color: 'white' }}>
              Privacy Policy
            </h1>
           
          </div>
        </div>
      </div>

      <div style={{ maxWidth: '900px', margin: '0 auto', padding: isMobile ? '20px' : '40px' }}>
        {/* Introduction */}
        <div style={{ background: 'white', borderRadius: '16px', padding: '24px', marginBottom: '20px', border: '1px solid rgba(220,38,38,0.1)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
            <Shield size={24} color="#dc2626" />
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, margin: 0 }}>Introduction</h2>
          </div>
          <p style={{ color: '#475569', lineHeight: 1.6, marginBottom: '12px' }}>
            Sugandhi Flowers ("we", "our", "us") respects your privacy and is committed to protecting your personal data. 
            This privacy policy explains how we collect, use, disclose, and safeguard your information when you use our 
            mobile application Sugandhi Flowers (the "App").
          </p>
          <p style={{ color: '#64748b', fontSize: '0.85rem' }}>
            Please read this privacy policy carefully. If you do not agree with the terms, please do not access the App.
          </p>
        </div>

        {/* Information We Collect */}
        <div style={{ background: 'white', borderRadius: '16px', padding: '24px', marginBottom: '20px', border: '1px solid rgba(220,38,38,0.1)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
            <Database size={24} color="#dc2626" />
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, margin: 0 }}>Information We Collect</h2>
          </div>
          
          <h3 style={{ fontWeight: 600, marginTop: '16px', marginBottom: '8px' }}>Personal Information You Provide</h3>
          <ul style={{ color: '#475569', lineHeight: 1.6, paddingLeft: '20px' }}>
            <li><strong>Create an account:</strong> Name, email address, phone number</li>
            <li><strong>Place an order:</strong> Delivery address, contact number, order details</li>
            <li><strong>Decoration enquiry:</strong> Name, email, phone number, event details, budget</li>
            <li><strong>Update your profile:</strong> Name, email, phone number, address, pincode</li>
          </ul>

          <h3 style={{ fontWeight: 600, marginTop: '16px', marginBottom: '8px' }}>Information Automatically Collected</h3>
          <ul style={{ color: '#475569', lineHeight: 1.6, paddingLeft: '20px' }}>
            
            <li>Usage data (pages viewed, order history)</li>
           
          </ul>
        </div>

        {/* How We Use Information */}
        <div style={{ background: 'white', borderRadius: '16px', padding: '24px', marginBottom: '20px', border: '1px solid rgba(220,38,38,0.1)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '16px' }}>
            <Eye size={24} color="#dc2626" />
            <h2 style={{ fontSize: '1.2rem', fontWeight: 700, margin: 0 }}>How We Use Your Information</h2>
          </div>
          <ul style={{ color: '#475569', lineHeight: 1.6, paddingLeft: '20px' }}>
            <li>Order processing and delivery</li>
            <li>Account management</li>
            <li>Customer service and support</li>
            <li>Decoration enquiry responses</li>
            <li>Order updates and OTP notifications</li>
            <li>App improvement and analytics</li>
          </ul>
        </div>

        

        {/* Your Rights */}
        <div style={{ background: 'white', borderRadius: '16px', padding: '24px', marginBottom: '20px', border: '1px solid rgba(220,38,38,0.1)' }}>
          <h2 style={{ fontSize: '1.2rem', fontWeight: 700, marginBottom: '16px' }}>Your Rights</h2>
          <ul style={{ color: '#475569', lineHeight: 1.6, paddingLeft: '20px' }}>
            <li>Access your personal data</li>
            <li>Correct/update your information</li>
            <li>Request deletion of your account</li>
            <li>Opt-out of notifications</li>
          </ul>
        </div>

        {/* Contact */}
        <div style={{ background: 'linear-gradient(135deg, #fff5f5, #fff)', borderRadius: '16px', padding: '24px', border: '1px solid #dc2626' }}>
          <h2 style={{ fontSize: '1.2rem', fontWeight: 700, marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Phone size={20} color="#dc2626" /> Contact Us
          </h2>
          <p style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Mail size={16} color="#dc2626" /> <strong>Email:</strong> sugandhiflowerseo@gmail.com
          </p>
          <p style={{ marginBottom: '8px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Phone size={16} color="#dc2626" /> <strong>Phone:</strong> +91-9130720201
          </p>
          <p style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <MapPin size={16} color="#dc2626" /> <strong>Address:</strong> Solapur, Maharashtra, India
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;